module.exports = __webpack_public_path__ + "static/media/sidebar-approvals.39829cba.svg";